import {
  ApplyingRule,
  IFunctionElementUnion,
  IStaticElementUnion,
  InputElementUnion,
  isFunctionElement,
  isInputElement,
  resolveRequiredHiddenLabel,
  IRepeatableElementUnion,
} from "@graffer-inc/form-schema";
import React from "react";

export type Props = {
  thenRule: ApplyingRule;
  thenCandidates: Array<
    | InputElementUnion
    | IFunctionElementUnion
    | IStaticElementUnion
    | IRepeatableElementUnion
  >;
  element:
    | InputElementUnion
    | IFunctionElementUnion
    | IStaticElementUnion
    | IRepeatableElementUnion;
};

export const PublishedSchemaApplicantThenRuleEditor: React.FC<Props> = ({
  thenRule: r,
  thenCandidates,
  element,
}) => {
  return (
    <>
      <div className="field">
        <label className="label">適用対象</label>
        <div className="control">
          <p>{thenCandidates.find((e) => e.id === r.id)!.label.text}</p>
        </div>
      </div>
      <div className="field">
        <label className="label">項目名</label>
        <div className="control">
          <p>{r.rule.label?.text || "設定なし"}</p>
        </div>
      </div>
      {isInputElement(element) && (
        <div className="field">
          <label className="label">必須・表示設定</label>
          <div className="control">
            <p>{resolveRequiredHiddenLabel(r.rule)}</p>
          </div>
        </div>
      )}
      {isFunctionElement(element) && (
        <div className="field">
          <label className="label">表示・非表示設定</label>
          <div className="control">
            <p>{r.rule.hidden ? "非表示" : "表示"}</p>
          </div>
        </div>
      )}
    </>
  );
};
